import { isNotStoreEnv, isStoreEnv } from '../permissions/rules/visibility.combinators';
import { VisibilityRuleMap } from '../permissions/types/featureVisibility.types';
import { AccountsReceivableFeatureKey, F } from '../permissions/types/features.keys';

export const accountsReceivableVisibilityRules: Pick<
  VisibilityRuleMap,
  AccountsReceivableFeatureKey
> = {
  [F.accountsReceivable.payableFiltersInStore]: isNotStoreEnv,
  [F.accountsReceivable.payableBrandColumnInStore]: isStoreEnv,
};
